/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

 /* eslint-disable import/prefer-default-export */
export const unitBase = 4;
export const rowSpacing = unitBase * 3; // 12px
export const rowSpacingDesktop = unitBase * 2.5; // 10px

export const fontSize = {
    micro: 9,
    small: 12,
    body: 14,
    component: 16,
    h2: 14,
    h1: 20,
    large: 18,
    larger: 24,
    largest: 32
};

export const fontSizeDesktop = {
    micro: 9,
    smaller: 10,
    small: 12,
    body: 14,
    component: 16,
    title: 16,
    h2: 16,
    h1: 20,
    large: 20,
    larger: 24,
    largest: 32,
};


export const CUSTOM_BREAKPOINTS = {
    tabPortrait: 768,
    tabLandscape: 1023,
};

export const enterpriseCSS = {
    palette: {
        body: '#000000',
        black: '#000000',
        blue: '#1F6BC6',
        gray1: '#696A69',
        gray2: '#D8D8D8',
        gray3: '#EDEDEA',
        green: '#64B00C',
        red: '#D0021B',
        white: '#FFFFFF',
        success: '#25C066',
        error: '#D0021B',
        darkRed: '#a1001a',
        hoverRed: '#790000',
        darkGray: '#161616',
        checkbox: '#797979',
        button: {
            darkGray: '#2f2f2f',
            accountCallToAction: {
                '18F': '#65388b',
                HD: '#2f2f2f',
                '18B': '#9c0352',
                CCO: '#542d24',
                TPF: '#b01116',
                SCH: '#512c1d',
                SY: '#3c3c35',
                WLF: '#5c5757',
                FBQ: '#7340a0',
                BRY: '#223970',
                VC: '#cf3d02',
                FL: '#0E4728'
            }

        },
        buyAgain: {
            grey1: '#ededeb',
            grey2: '#5a5a58',
            stockErrorBackground: '#de0c0c;',
        },
        base: {
            h2Divider: {
                color: '#696A69',
                backgroundColor: '#EDEDEA',
            },
        },
        modal: {
            title: {
                size: 18,
                color: '#696A69',
                backgroundColor: '#EDEDEA',
            },
        },
    },
};
